import { EnumLoginMethod as AnalyticsLoginMethod } from '@calm/evexia-analytics';
import { getLoginMethodByUserId } from '@calm/web-common/dist/user-id';

export const getAnalyticsLoginMethodByUserId = (
    userId: string
): AnalyticsLoginMethod => AnalyticsLoginMethod[getLoginMethodByUserId(userId)];
